import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled from 'styled-components';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import { useModalContext } from './ModalContext.js';
var ButtonWrapper = styled(Box)(css({
  width: "36px",
  height: "36px",
  position: "absolute",
  top: ["10px", "14px"],
  borderRadius: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  color: "textPrimary",
  transition: "background-color .2s ease-in-out",
  ":hover": {
    backgroundColor: ["transparent", "background"]
  }
}));
var ModalHeaderButton = React__default.forwardRef(function (_a, ref) {
  var align = _a.align,
    children = _a.children,
    rest = __rest(_a, ["align", "children"]);
  return React__default.createElement(ButtonWrapper, __assign({
    left: align === "left" ? ["8px", "18px"] : "inherit",
    right: align === "right" ? ["8px", "18px"] : "inherit"
  }, rest, {
    ref: ref
  }), children);
});
var ModalCloseButton = function ModalCloseButton(props) {
  var onClose = useModalContext().onClose;
  return React__default.createElement(ModalHeaderButton, __assign({
    align: "right",
    onClick: onClose
  }, props), React__default.createElement(Icon, {
    icon: "close",
    fontSize: ["24px", "20px"]
  }));
};
var ModalBackButton = function ModalBackButton(props) {
  return React__default.createElement(ModalHeaderButton, __assign({
    align: "left"
  }, props), React__default.createElement(Icon, {
    icon: "arrow_left",
    fontSize: ["24px", "20px"]
  }));
};
var ModalSupportButton = function ModalSupportButton(props) {
  return React__default.createElement(ModalHeaderButton, __assign({
    align: "right"
  }, props), React__default.createElement(Icon, {
    icon: "support",
    fontSize: ["24px", "20px"]
  }));
};
export { ButtonWrapper, ModalBackButton, ModalCloseButton, ModalHeaderButton, ModalSupportButton };